import fetch from 'isomorphic-fetch';

import { getHeaders } from '~/utils';
import get from 'lodash/get';
import { responseReceived } from '~/lib/mobile-x';

export const fetchCardDetails = async ({ globalData }) => {

  const { host, protocol } = window.location;

  let data;
  try {
    data = await submit({
      globalData,
      url: `${protocol}//${host}/api/journey-details?offerId=`,
    });
  } catch (err) {
    throw Error ('Error in API fetchCardDetails');
  }
  return data;
};

const submit = async ({ globalData, url }) => {

  let submitUrl, response;

  submitUrl = `${url}${get(globalData, 'offerId')}`;
  response = await fetch(submitUrl, {
    method: 'get',
    headers: getHeaders({
      globalData,
    }),
  });
  responseReceived(get(response, 'status'));
  if (!response.ok) {
    throw Error(response.statusText);
  }
  let data = await response.json();
  return data;
};
